export default {
    create_canned_command_create_title: "Nuevo Comando",
    create_canned_command_edit_title: "Editar Comando",
    create_canned_command_create_success_message: "Se ha creado el comando",
    create_canned_command_update_success_message: "El comando ha sido editado",
    create_canned_command_manufacturer: "Fabricante",
    create_canned_command_label: "Etiqueta",
    create_canned_command_command: "Comando",
    create_canned_command_unit_type: "tipo de Unidad",
    create_canned_command_via: "Vía",
    create_canned_command_via_sms: "SMS",
    create_canned_command_via_ota: "OTA",
    create_canned_command_create_active: "Activo",
    create_canned_command_create_inactive: "Inactivo",
    create_canned_command_apply_to_all_types: "Aplica a Todos los Tipos"
}